import Header from './components/Header';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import ProblemSection from './components/ProblemSection';
import DiagnosisFramework from './components/DiagnosisFramework';
import SampleReport from './components/SampleReport';
import HowItWorks from './components/HowItWorks';
import CaseStudy from './components/CaseStudy';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Header />
      <HeroSection />
      <StatsBar />
      <ProblemSection />
      <DiagnosisFramework />
      <SampleReport />
      <HowItWorks />
      <CaseStudy />
      <Footer />
    </main>
  );
}
